import { tokens } from '../../../../theme/generated/tokens';

export const defaults = {
  margin: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1,
  },
  sectorGap: 1,
  cornerRadius: 0,
  outerRadius: '100%',
  fill: tokens.theme.data.grey100,
  strokeWidth: 1,
};
